import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Film, BookOpen, Loader2, Wand2 } from "lucide-react";
import { TopNav } from "../components/TopNav";
import { api, apiError } from "../lib/api";

const GENRES = ["Shonen Action", "Dark Fantasy", "Sci-Fi Mecha", "Romance", "Isekai", "Psychological Thriller", "Slice of Life", "Horror", "Sports", "Cyberpunk"];

export default function CreateProjectPage() {
  const [type, setType] = useState("anime");
  const [title, setTitle] = useState("");
  const [genre, setGenre] = useState(GENRES[0]);
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/projects", { title, type, genre, description });
      navigate(`/project/${data.id}`);
    } catch (err) {
      setError(apiError(err));
      setBusy(false);
    }
  };

  return (
    <div className="mvp-page" data-testid="create-page">
      <TopNav />
      <main className="mvp-main mvp-narrow">
        <h1>Create a Project</h1>
        <p className="mvp-sub">Give the Story Context Engine a premise — it builds the rest.</p>

        <form onSubmit={submit} className="mvp-form">
          <div className="mvp-type-toggle" data-testid="type-toggle">
            <button
              type="button"
              className={type === "anime" ? "active anime" : ""}
              onClick={() => setType("anime")}
              data-testid="type-anime-btn"
            >
              <Film size={20} /> Anime
            </button>
            <button
              type="button"
              className={type === "manga" ? "active manga" : ""}
              onClick={() => setType("manga")}
              data-testid="type-manga-btn"
            >
              <BookOpen size={20} /> Manga
            </button>
          </div>

          <label>Title</label>
          <input
            type="text"
            placeholder="e.g. Crimson Requiem"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            maxLength={120}
            data-testid="create-title-input"
          />

          <label>Genre</label>
          <select value={genre} onChange={(e) => setGenre(e.target.value)} data-testid="create-genre-select">
            {GENRES.map((g) => (
              <option key={g} value={g}>{g}</option>
            ))}
          </select>

          <label>Premise</label>
          <textarea
            placeholder="Describe your idea — the world, the hero, the central conflict… (min 10 characters)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            minLength={10}
            maxLength={2000}
            rows={5}
            data-testid="create-description-input"
          />

          {error && <div className="mvp-error" data-testid="create-error">{error}</div>}

          <button type="submit" className="btn-primary mvp-cta" disabled={busy} data-testid="create-submit-btn">
            {busy ? <Loader2 size={18} className="mvp-spin" /> : <><Wand2 size={18} /> Generate Story Universe</>}
          </button>
        </form>
      </main>
    </div>
  );
}
